// Brand logos for the Integrations panel. Sourced from the Simple
// Icons CDN (https://simpleicons.org) — the project provides
// brand-correct SVGs in the official brand color when no color is
// specified, or in a chosen hex when supplied. They serve over a
// global CDN with strong cache headers, so the UI stays fast even
// without bundling SVG content directly.
//
// `slug` follows simpleicons.org conventions (lowercase, no spaces).
// `bg` is the soft tile background tint shown behind the icon.

export interface ProviderLogo {
  slug: string;
  bg: string;
}

const PROVIDER_LOGOS: Record<string, ProviderLogo> = {
  stripe: { slug: "stripe", bg: "bg-indigo-50" },
  shopify: { slug: "shopify", bg: "bg-emerald-50" },
  tiktok: { slug: "tiktok", bg: "bg-zinc-100" },
  instagram: { slug: "instagram", bg: "bg-pink-50" },
  facebook: { slug: "facebook", bg: "bg-blue-50" },
  google_calendar: { slug: "googlecalendar", bg: "bg-blue-50" },
  gmail: { slug: "gmail", bg: "bg-red-50" },
  slack: { slug: "slack", bg: "bg-purple-50" },
  mailchimp: { slug: "mailchimp", bg: "bg-yellow-50" },
  hubspot: { slug: "hubspot", bg: "bg-orange-50" },
  zoom: { slug: "zoom", bg: "bg-sky-50" },
  quickbooks: { slug: "quickbooks", bg: "bg-emerald-50" },
};

const DEFAULT_LOGO: ProviderLogo = { slug: "googlechrome", bg: "bg-zinc-100" };

export function logoFor(providerId: string): ProviderLogo {
  return PROVIDER_LOGOS[providerId] ?? DEFAULT_LOGO;
}

/** CDN URL for the logo. Simple Icons returns a 24x24 SVG by default. */
export function logoUrl(providerId: string): string {
  const { slug } = logoFor(providerId);
  return `https://cdn.simpleicons.org/${slug}`;
}
